var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-container"},[_c('line-chart',{ref:"line",attrs:{"id":"line","chart-data":_vm.chartData,"chart-options":_vm.chartOptions(),"styles":_vm.myStyles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }